import classNames from "classnames";
import { PropsWithChildren } from "react";

import css from "./unordered_list.module.scss";

type UnorderedListProps = {
  className?: string;
  qaId?: string;
};

export const UnorderedList = ({ className, qaId, children }: PropsWithChildren<UnorderedListProps>) => (
  <ul className={classNames(css.ul, className)} data-qa-id={qaId}>
    {children}
  </ul>
);

type ListItemProps = {
  className?: string;
  qaId?: string;
};

export const ListItem = ({ className, qaId, children }: PropsWithChildren<ListItemProps>) => (
  <li className={classNames(css.li, className)} data-qa-id={qaId}>
    {children}
  </li>
);
